import loadRepository from "../repositories/LoadRepository";
import { buildSearchParams } from "../utils/requestHelpers";

export class LoadService {
  static GetLoad(instance, loadId) {
    const repo = new loadRepository;
    const params = buildSearchParams(
      {
        id: loadId
      }
    );

    return repo.getLoad(instance, params);
  }

  static UpdateLoadStatus(instance, payload) {
    const repo = new loadRepository;

    return repo.updateLoadStatus(instance, payload);
  }

  static GetLaneHistory(instance, loadId, originSearchMiles, destinationSearchMiles, revenueCodeId) {
    const repo = new loadRepository;
    const params = buildSearchParams(
      {
        orderId: loadId,
        lookBackDays: 365,
        originSearchMiles: originSearchMiles,
        destinationSearchMiles: destinationSearchMiles,
        mode: revenueCodeId
      }
    );

    return repo.getLaneHistory(instance, params);
  }

  static GetLoadHistory(instance, originCityName, originState, destinationCityName, destinationState, revenueCodeId) {
    const repo = new loadRepository;
    const params = buildSearchParams(
      {
        lookBackDays: 365,
        originCity: originCityName,
        originState: originState,
        destinationCity: destinationCityName,
        destinationState: destinationState,
        mode: revenueCodeId
      }
    );

    return repo.getLoadHistory(instance, params);
  }

  static GetLoads(instance, loadStatus) {
    const repo = new loadRepository;
    const params = buildSearchParams(
      {
        loadStatus: loadStatus,
        daysBack: 365,
        daysOut: 60
      }
    );

    return repo.getLoads(instance, params);
  }

  static GetLoadComments(instance, loadId, commentTypeId) {
    const repo = new loadRepository;
    const params = buildSearchParams({
      orderId: loadId,
      commentTypeIds: commentTypeId
    });

    return repo.getLoadComments(instance, params).then();
  }

  static GetLoadCallins(instance, loadId) {
    const repo = new loadRepository;
    return repo.getLoadCallins(instance, loadId).then();
  }

  static FindLoadsById(instance, loadId) {
    const repo = new loadRepository;
    return repo.findLoadsById(instance, loadId).then();
  }

  static PostLoad(instance, load) {
    const repo = new loadRepository;
    return repo.postLoad(instance, load);
  }

  static UnpostLoad(instance, payload) {
    const repo = new loadRepository;
    return repo.unpostLoad(instance, payload);
  }
}